<div>{{ date | date: ('date.format-number' | translate) }}</div>
